import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';

// Textúra beimportálása!
// @ts-ignore
import textureBg from '../videos/texture.png'; 

const RSVPForm: React.FC = () => {
  return (
    <Box 
      id="rsvp-section" 
      sx={{ 
        backgroundColor: '#ffffff', 
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
        backgroundBlendMode: 'multiply',
        py: 15 
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Paper elevation={0} sx={{ p: { xs: 2, md: 8 }, bgcolor: 'white', border: '1px solid rgba(137, 207, 240, 0.3)', borderRadius: 4 }}>
            
            <Box sx={{ textAlign: 'center', mb: 6 }}>
              <Typography variant="h6" sx={{ letterSpacing: 3, color: 'primary.main'}}>
                Részvétel Visszaigazolása
              </Typography>
              <Typography variant="h2" sx={{ mt: 2, mb: 2, color: '#333' }}>
                Ott leszel velünk?
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.primary', fontSize: '1.1rem' }}>
                Kérjük, töltsd ki az alábbi űrlapot legkésőbb 2026. június végéig, hogy megfelelően készülhessünk!
              </Typography>
            </Box>

            {/* GOOGLE FORM BEÁGYAZÁSA */}
            <Box 
              sx={{ 
                width: '100%', 
                display: 'flex', 
                justifyContent: 'center',
                overflow: 'hidden', 
                borderRadius: 2
              }}
            >
              <iframe 
                src="https://docs.google.com/forms/d/1gcIEN6RidYIRZ1GsplPKdkk5zSN-QSYs8Ecq7HwyQQc/viewform?embedded=true" 
                width="100%" 
                height="800" 
                frameBorder="0" 
                marginHeight={0} 
                marginWidth={0}
                title="RSVP Form"
                style={{ border: 'none' }}
              >
                Betöltés...
              </iframe>
            </Box>

          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default RSVPForm;